// (function ($, Drupal) {
//   // $(document).ready(function() {
//   //   if ($(window).width() < 960) {
//       $('#sidebarCollapse').on('click', function () {
//         $('#sidebar, #content-nav').toggleClass('active');
//         $('.collapse.in').toggleClass('in');
//         $('a[aria-expanded=true]').attr('aria-expanded', 'false');
//       });
//     // }
//   // });
// })(jQuery, Drupal);

function openSlideMenu(){
  document.getElementById('menu').style.width = '250px';
  document.getElementById('page').style.marginLeft = '250px';
}
function closeSlideMenu(){
  document.getElementById('menu').style.width = '0';
  document.getElementById('page').style.marginLeft = '0';
}